"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var Carousel_module_scss_1 = __importDefault(require("./Carousel.module.scss"));
var ui_1 = require("@aperza/ui");
var react_i18next_1 = require("react-i18next");
var leftTransition = 'left 0.3s ease-in-out';
var leftNoTransition = 'left 0.3s ease-in-out';
var Carousel = function (props) {
    var _a, _b;
    var _c = props.items, items = _c === void 0 ? [] : _c;
    var carouselEl = react_1.useRef(null);
    var carouselSliderEl = react_1.useRef(null);
    var _d = react_1.useState(0), carouselHeight = _d[0], setCarouselHeight = _d[1];
    var _e = react_1.useState(0), itemWidth = _e[0], setItemWidth = _e[1];
    var _f = react_1.useState(0), page = _f[0], setPage = _f[1];
    var _g = react_1.useState(items.length), pageCount = _g[0], setPageCount = _g[1];
    var _h = react_1.useState(leftNoTransition), transition = _h[0], setTransition = _h[1];
    var t = react_i18next_1.useTranslation().t;
    var updateWidth = function () {
        setTransition(leftNoTransition);
        var width = carouselEl.current ? carouselEl.current.clientWidth : 0;
        var height = carouselSliderEl.current ? carouselSliderEl.current.clientHeight : 0;
        if (width) {
            setItemWidth(width);
        }
        if (height)
            setCarouselHeight(height);
    };
    ui_1.useWindowResize(updateWidth);
    var onClickPrev = function () {
        if (page > 0) {
            setTransition(leftTransition);
            var newPage = page - 1;
            setPage(newPage);
        }
    };
    var onClickNext = function () {
        if (page + 1 < pageCount) {
            setTransition(leftTransition);
            var newPage = page + 1;
            setPage(newPage);
        }
    };
    var hasPrev = function () {
        return pageCount > 0 && page > 0;
    };
    var hasNext = function () {
        return pageCount > 0 && page + 1 < pageCount;
    };
    react_1.useEffect(function () {
        updateWidth();
        setPageCount(items.length);
    }, [items]);
    var images = items.map(function (item, index) {
        return (react_1.default.createElement("div", { key: index, className: Carousel_module_scss_1.default.CarouselItem, style: { width: itemWidth } },
            react_1.default.createElement("div", { className: Carousel_module_scss_1.default.imageWrapper },
                react_1.default.createElement("img", { className: Carousel_module_scss_1.default.image, src: item.imageUrl, onLoad: updateWidth }))));
    });
    return (react_1.default.createElement("div", { ref: carouselEl, className: Carousel_module_scss_1.default.Carousel, style: { height: carouselHeight } },
        react_1.default.createElement("div", null,
            react_1.default.createElement("i", { className: clsx_1.default('fa', 'fa-angle-left', Carousel_module_scss_1.default.CarouselButtonLeft, (_a = {},
                    _a[Carousel_module_scss_1.default.CarouselButtonDisabled] = !hasPrev(),
                    _a)), "aria-hidden": "true", onClick: onClickPrev })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("i", { className: clsx_1.default('fa', 'fa-angle-right', Carousel_module_scss_1.default.CarouselButtonRight, (_b = {},
                    _b[Carousel_module_scss_1.default.CarouselButtonDisabled] = !hasNext(),
                    _b)), "aria-hidden": "true", onClick: onClickNext })),
        react_1.default.createElement("div", { className: Carousel_module_scss_1.default.CarouselPage },
            page + 1,
            "/",
            pageCount),
        react_1.default.createElement("div", { ref: carouselSliderEl, className: Carousel_module_scss_1.default.CarouselSlider, style: {
                zIndex: -1,
                transition: transition,
                width: itemWidth * pageCount,
                left: 0 - page * itemWidth,
            } }, images)));
};
Carousel.propTypes = {
    items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        name: prop_types_1.default.string,
        imageUrl: prop_types_1.default.string,
    })),
};
exports.default = Carousel;
